var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystemBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verify"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3275",
    x: 2.5,
    y: 2.5,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3276",
    x: 9.90234,
    y: -0.5,
    width: 15,
    height: 15,
    rx: 2,
    transform: "rotate(45 9.90234 -0.5)",
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.97266 10.3118L9.30599 12.6452L13.9727 7.97852",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemBadge);
export default __webpack_public_path__ + "static/media/system-badge.3fb17310dc3bc5f5323c29cc564d8d7a.svg";
export { ForwardRef as ReactComponent };